import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const VALIDATE_PRICE_CARD = gql`
  mutation validatePriceCard($quoteId: Int!) {
    validatePriceCard(quoteId: $quoteId)
  }
`;

export const APPLY_LAST_PRICE_CARD_VERSION = gql`
  mutation applyLatestPriceCardVersion($quoteId: Int!) {
    applyLatestPriceCardVersion(quoteId: $quoteId)
  }
`;

export const COMPUTE_PRODUCTS = gql`
  mutation computeProducts($quoteId: Int!) {
    computeProducts(quoteId: $quoteId) {
      ...quoteProduct
    }
  }
  ${Fragments.quoteProduct}
`;

export const EXECUTE_ZOOT_RISK_CALL = gql`
  mutation executeZootRiskCall($quoteId: Int!, $currentStep: Int!) {
    executeZootRiskCall(quoteId: $quoteId, currentStep: $currentStep)
  }
`;

export const EXECUTE_ZOOT_SCORING_AUTO_CALL = gql`
  mutation executeZootScoringAutoCall($quoteId: Int!) {
    executeZootScoringAutoCall(quoteId: $quoteId)
  }
`;
